import React, { useEffect, useState } from "react";
import { Menu, Search } from "lucide-react";
import CourseOverview from "./CourseOverview";
import CourseOfferings from "./CourseOfferings";
import CourseOverview2 from "./CourseOverview2";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "../../api/api";
import { useStorage } from "../../hooks/useLocalStorage";

export default function RetreatDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  
  const [user, setUser, loadUser] = useStorage("use", null);
  const [retreat, setRetreat] = useState({});
  const currentDate = new Date();
  const endDate = new Date(retreat?.startDate);


  console.log('====================================');
  console.log(currentDate <= endDate);
  console.log(endDate);
  useEffect(() => {
    getData(`/retreats/${id}`)
      .then((e) => {
        console.log(e.data);
        setRetreat(e.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <div className="relative h-screen bg-gradient-to-r from-cyan-900 to-blue-900 text-white">
        <header className="absolute top-0 left-0 right-0 z-10 flex justify-center items-center p-4">
          {/* <img
            src="https://i0.wp.com/plumvillage.org/wp-content/uploads/2019/07/plumvillage-white.png?fit=322%2C83&ssl=1"
            alt="Plum Village"
            className="h-10"
          /> */}
        </header>

        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("${
              retreat.retreatImages && retreat.retreatImages[0]?.url
            }")`,
          }}
        ></div>

        <div className="relative flex justify-end  items-center  h-full ">
          <div className="relative z-10 flex  flex-col justify-center items-start h-full px-8 max-w-3xl">
            <div className="bg-black bg-opacity-50 p-6 rounded-lg">
              {/* <h2 className="text-xl font-semibold mb-4">ONLINE COURSE</h2> */}
              <h1 className="text-4xl md:text-6xl font-bold mb-4 text-yellow-400">
                {retreat.name}
              </h1>
              <p className="text-lg mb-6">
                <div
                  className="uploaded-content line-clamp-3"
                  dangerouslySetInnerHTML={{ __html: retreat.description }}
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="font-sans max-w-7xl mx-auto p-6">
        {/* <div className="text-right mb-6">
          <span className="text-gray-600">
            Are you currently participating in this course?
          </span>{" "}
          <a href="#" className="text-yellow-500 hover:underline">
            Login
          </a>
        </div> */}

        <div className="flex flex-col md:flex-row gap-8">
          <div className="md:w-2/3">
            <h1 className="text-3xl font-semibold mb-6">{retreat.name}</h1>
            <div
              className="uploaded-content "
              dangerouslySetInnerHTML={{ __html: retreat.description }}
            />
          </div>

          <div className="md:w-1/3   ">
            <div className="bg-gray-100 p-6 rounded-lg">
              {/* <h2 className="text-2xl font-semibold mb-4">7 week course:</h2>
              <ul className="list-disc list-inside mb-6 text-gray-700">
                <li>3-7 hours per week,</li>
                <li>Combination of self-paced content and live events.</li>
              </ul> */}
              <h3 className="text-xl font-semibold mt-6 mb-2">
                Prices: ${retreat.cost}
              </h3>
              <h3 className="text-xl font-semibold mt-6 mb-2">
                {retreat.remainingSlots} slot
              </h3>
              <p className="text-gray-700 mb-4">Scholarships are available</p>

              <h3 className="text-xl font-semibold mb-2">
                Dates for next course:
              </h3>
              <p className="text-gray-700 mb-2">
                Start Date:{retreat.startDate}
              </p>
              <p className="text-gray-700 mb-6">End Date: {retreat.endDate}</p>
              {user.id ? (
                <>
                  {retreat.remainingSlots && currentDate <= endDate ? (
                    <button
                      onClick={() => {
                        navigate(`/retreat/register/${id}`);
                      }}
                      className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-4 rounded transition duration-300"
                    >
                      Register
                    </button>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <button
                  onClick={() => {
                    navigate(`/login?retreat-register=${id}`);
                  }}
                  className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-4 rounded transition duration-300"
                >
                  Login
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* <CourseOverview retreat={retreat} /> */}
      {/* <CourseOfferings /> */}
      <CourseOverview2 retreat={retreat} />
    </>
  );
}
